import { useQuery } from '@apollo/client';

import { EVENTS } from '../graphql/query/eventsQuery.graphql';

export const useEventsQuery = () => {
  return useQuery(EVENTS);
};
